module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "dialog-view"
  }, [_c('VwButton', {
    attrs: {
      "plain": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog('iOS')
      }
    }
  }, [_vm._v("iOS")]), _vm._v(" "), _c('VwButton', {
    attrs: {
      "plain": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog('Android')
      }
    }
  }, [_vm._v("Android")]), _vm._v(" "), _c('VwButton', {
    attrs: {
      "plain": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog('iOS2')
      }
    }
  }, [_vm._v("iOS with 2 buttons")]), _vm._v(" "), _c('VwButton', {
    attrs: {
      "plain": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog('Android2')
      }
    }
  }, [_vm._v("Android with 2 buttons")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-c521d72e!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/dialogView.vue
// module id = 285
// module chunks = 0